import GetProjects from "../firebase/fetchDB";
import { Link } from "react-router-dom";

const Home = () => {
  const { projects, isPending } = GetProjects();

  return (
    <div className="home">
      <div className="home-header">
        <h1>
          Hi, I'm <mark className="mark-name"> Mircea Martin </mark>
        </h1>
      </div>
      <div className="home-main">
        <h1>
          I am a developer focusing on
          <mark> Android</mark> and
          <mark className="webDev"> Front End Web Development</mark>
        </h1>
      </div>
      <div className="home-website-details">
        <h1>
          Here are some of my personal <Link className="h1-link" to="/portofolio">Projects</Link>
        </h1>
      </div>
      <div className="home-main">
        <h1>
          This website was coded in <mark className="webDev"> React </mark> and and uses <mark className="firebase"> Firebase </mark> for the projects Database
        </h1>
      </div>
    </div>
  );
};

export default Home;
